import React from 'react';
import { Link } from 'react-router-dom';
import { CaseStudyDataTranslated } from '../../data/casestudy/CaseStudyDataTranslated.js';
import Tilty from 'react-tilty';
import { slugify } from '../../utils/index.js';
import { useLanguage } from '../../context/LanguageContext.js';

const CaseStudyProp = () => {
    const { language } = useLanguage();
    const allData = CaseStudyDataTranslated[language];
    
    const getTipAnimation = (id) => {
        switch(id) {
            case 1: // Organize com antecedência
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <rect x="50" y="50" width="200" height="200" rx="10" fill="#3498db" opacity="0.1"/>
                        <rect x="70" y="70" width="160" height="160" rx="5" fill="#fff" stroke="#3498db" strokeWidth="3"/>
                        <line x1="100" y1="100" x2="200" y2="100" stroke="#2ecc71" strokeWidth="4" className="check-1"/>
                        <line x1="100" y1="130" x2="200" y2="130" stroke="#2ecc71" strokeWidth="4" className="check-2"/>
                        <line x1="100" y1="160" x2="180" y2="160" stroke="#2ecc71" strokeWidth="4" className="check-3"/>
                        <circle cx="100" cy="100" r="8" fill="#2ecc71" className="check-dot-1"/>
                        <circle cx="100" cy="130" r="8" fill="#2ecc71" className="check-dot-2"/>
                        <circle cx="100" cy="160" r="8" fill="#2ecc71" className="check-dot-3"/>
                        <text x="150" y="200" textAnchor="middle" fill="#3498db" fontSize="16" fontWeight="bold">PLANEAMENTO</text>
                        <style jsx>{`
                            .check-1, .check-2, .check-3 { stroke-dasharray: 100; stroke-dashoffset: 100; }
                            .check-1 { animation: drawLine 1s ease-in-out 0.5s forwards; }
                            .check-2 { animation: drawLine 1s ease-in-out 1s forwards; }
                            .check-3 { animation: drawLine 1s ease-in-out 1.5s forwards; }
                            .check-dot-1, .check-dot-2, .check-dot-3 { opacity: 0; }
                            .check-dot-1 { animation: fadeIn 0.3s ease-in-out 0.5s forwards; }
                            .check-dot-2 { animation: fadeIn 0.3s ease-in-out 1s forwards; }
                            .check-dot-3 { animation: fadeIn 0.3s ease-in-out 1.5s forwards; }
                            @keyframes drawLine { to { stroke-dashoffset: 0; } }
                            @keyframes fadeIn { to { opacity: 1; } }
                        `}</style>
                    </svg>
                );
            case 2: // Numere as caixas
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <g className="box-1" transform="translate(80, 100)">
                            <rect x="0" y="0" width="60" height="60" fill="#e74c3c" rx="3"/>
                            <text x="30" y="38" textAnchor="middle" fill="#fff" fontSize="24" fontWeight="bold">1</text>
                        </g>
                        <g className="box-2" transform="translate(160, 80)">
                            <rect x="0" y="0" width="60" height="60" fill="#3498db" rx="3"/>
                            <text x="30" y="38" textAnchor="middle" fill="#fff" fontSize="24" fontWeight="bold">2</text>
                        </g>
                        <g className="box-3" transform="translate(120, 160)">
                            <rect x="0" y="0" width="60" height="60" fill="#f39c12" rx="3"/>
                            <text x="30" y="38" textAnchor="middle" fill="#fff" fontSize="24" fontWeight="bold">3</text>
                        </g>
                        <style jsx>{`
                            .box-1 { animation: floatBox 3s ease-in-out infinite; }
                            .box-2 { animation: floatBox 3s ease-in-out infinite 0.3s; }
                            .box-3 { animation: floatBox 3s ease-in-out infinite 0.6s; }
                            @keyframes floatBox {
                                0%, 100% { transform: translateY(0) rotate(0deg); }
                                50% { transform: translateY(-15px) rotate(5deg); }
                            }
                        `}</style>
                    </svg>
                );
            case 3: // Cuidado com o Frágil
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <rect x="80" y="100" width="140" height="100" fill="#fff" stroke="#e74c3c" strokeWidth="4" rx="5"/>
                        <text x="150" y="145" textAnchor="middle" fill="#e74c3c" fontSize="20" fontWeight="bold">FRÁGIL</text>
                        <g className="warning-sign">
                            <path d="M150 60 L170 100 L130 100 Z" fill="#f1c40f"/>
                            <text x="150" y="95" textAnchor="middle" fill="#e74c3c" fontSize="24" fontWeight="bold">!</text>
                        </g>
                        <g className="glass-icon">
                            <rect x="120" y="210" width="60" height="40" fill="none" stroke="#3498db" strokeWidth="3" rx="3"/>
                            <line x1="150" y1="210" x2="150" y2="250" stroke="#3498db" strokeWidth="2"/>
                            <circle cx="135" cy="225" r="3" fill="#3498db" className="crack-1"/>
                            <circle cx="165" cy="235" r="3" fill="#3498db" className="crack-2"/>
                        </g>
                        <style jsx>{`
                            .warning-sign { animation: pulse 2s ease-in-out infinite; }
                            @keyframes pulse {
                                0%, 100% { transform: scale(1); opacity: 1; }
                                50% { transform: scale(1.1); opacity: 0.8; }
                            }
                            .crack-1, .crack-2 { animation: blink 1.5s ease-in-out infinite; }
                            @keyframes blink {
                                0%, 100% { opacity: 0.3; }
                                50% { opacity: 1; }
                            }
                        `}</style>
                    </svg>
                );
            case 4: // Eletrodomésticos
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <rect x="70" y="80" width="160" height="180" fill="#ecf0f1" stroke="#34495e" strokeWidth="3" rx="5"/>
                        <rect x="80" y="90" width="140" height="120" fill="#fff"/>
                        <rect x="90" y="100" width="120" height="15" fill="#3498db" opacity="0.3"/>
                        <circle cx="150" cy="220" r="8" fill="#2ecc71" className="power-off"/>
                        <line x1="100" y1="260" x2="200" y2="260" stroke="#95a5a6" strokeWidth="3"/>
                        <text x="150" y="280" textAnchor="middle" fill="#7f8c8d" fontSize="12">24h OFF</text>
                        <style jsx>{`
                            .power-off { animation: pulseOff 2s ease-in-out infinite; }
                            @keyframes pulseOff {
                                0%, 100% { opacity: 0.5; }
                                50% { opacity: 1; }
                            }
                        `}</style>
                    </svg>
                );
            case 5: // Mobiliário com conteúdo
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <rect x="80" y="100" width="140" height="120" fill="#8b4513" stroke="#654321" strokeWidth="3" rx="3"/>
                        <rect x="90" y="110" width="120" height="100" fill="#d2691e"/>
                        <line x1="100" y1="130" x2="200" y2="130" stroke="#654321" strokeWidth="2"/>
                        <line x1="100" y1="160" x2="200" y2="160" stroke="#654321" strokeWidth="2"/>
                        <rect x="105" y="140" width="30" height="15" fill="#3498db" opacity="0.6" className="drawer-content"/>
                        <rect x="145" y="140" width="30" height="15" fill="#2ecc71" opacity="0.6" className="drawer-content"/>
                        <rect x="105" y="170" width="30" height="15" fill="#e74c3c" opacity="0.6" className="drawer-content"/>
                        <circle cx="200" cy="120" r="5" fill="#95a5a6" className="handle"/>
                        <style jsx>{`
                            .drawer-content { animation: contentMove 3s ease-in-out infinite; }
                            @keyframes contentMove {
                                0%, 100% { transform: translateX(0); }
                                50% { transform: translateX(5px); }
                            }
                            .handle { animation: handleShake 2s ease-in-out infinite; }
                            @keyframes handleShake {
                                0%, 100% { transform: translateX(0); }
                                50% { transform: translateX(3px); }
                            }
                        `}</style>
                    </svg>
                );
            case 6: // Destinos diferentes
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <circle cx="100" cy="100" r="30" fill="#e74c3c" className="dest-1"/>
                        <circle cx="200" cy="100" r="30" fill="#3498db" className="dest-2"/>
                        <circle cx="150" cy="200" r="30" fill="#2ecc71" className="dest-3"/>
                        <path d="M100 100 L200 100" fill="none" stroke="#95a5a6" strokeWidth="2" strokeDasharray="5,5" className="route-1"/>
                        <path d="M100 100 L150 200" fill="none" stroke="#95a5a6" strokeWidth="2" strokeDasharray="5,5" className="route-2"/>
                        <path d="M200 100 L150 200" fill="none" stroke="#95a5a6" strokeWidth="2" strokeDasharray="5,5" className="route-3"/>
                        <text x="100" y="85" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="bold">A</text>
                        <text x="200" y="85" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="bold">B</text>
                        <text x="150" y="185" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="bold">C</text>
                        <style jsx>{`
                            .dest-1, .dest-2, .dest-3 { animation: destPulse 2s ease-in-out infinite; }
                            .dest-2 { animation-delay: 0.3s; }
                            .dest-3 { animation-delay: 0.6s; }
                            @keyframes destPulse {
                                0%, 100% { transform: scale(1); }
                                50% { transform: scale(1.1); }
                            }
                            .route-1, .route-2, .route-3 { animation: routeFlow 2s linear infinite; }
                            @keyframes routeFlow {
                                to { stroke-dashoffset: -20; }
                            }
                        `}</style>
                    </svg>
                );
            case 7: // Livros
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <g className="book-1" transform="translate(80, 120)">
                            <rect x="0" y="0" width="40" height="80" fill="#8b4513" rx="2"/>
                            <rect x="2" y="2" width="36" height="76" fill="#a0522d"/>
                            <line x1="5" y1="10" x2="35" y2="10" stroke="#654321" strokeWidth="1"/>
                            <line x1="5" y1="20" x2="30" y2="20" stroke="#654321" strokeWidth="1"/>
                        </g>
                        <g className="book-2" transform="translate(130, 110)">
                            <rect x="0" y="0" width="40" height="80" fill="#2c3e50" rx="2"/>
                            <rect x="2" y="2" width="36" height="76" fill="#34495e"/>
                            <line x1="5" y1="10" x2="35" y2="10" stroke="#1a252f" strokeWidth="1"/>
                            <line x1="5" y1="20" x2="30" y2="20" stroke="#1a252f" strokeWidth="1"/>
                        </g>
                        <g className="book-3" transform="translate(180, 125)">
                            <rect x="0" y="0" width="40" height="80" fill="#c0392b" rx="2"/>
                            <rect x="2" y="2" width="36" height="76" fill="#e74c3c"/>
                            <line x1="5" y1="10" x2="35" y2="10" stroke="#922b21" strokeWidth="1"/>
                            <line x1="5" y1="20" x2="30" y2="20" stroke="#922b21" strokeWidth="1"/>
                        </g>
                        <rect x="90" y="200" width="120" height="20" fill="#95a5a6" rx="3" className="box-bottom"/>
                        <text x="150" y="213" textAnchor="middle" fill="#fff" fontSize="10" fontWeight="bold">CAIXA PEQUENA</text>
                        <style jsx>{`
                            .book-1, .book-2, .book-3 { animation: bookStack 3s ease-in-out infinite; }
                            .book-2 { animation-delay: 0.2s; }
                            .book-3 { animation-delay: 0.4s; }
                            @keyframes bookStack {
                                0%, 100% { transform: translateY(0) rotate(0deg); }
                                50% { transform: translateY(-5px) rotate(2deg); }
                            }
                            .box-bottom { animation: boxPulse 2s ease-in-out infinite; }
                            @keyframes boxPulse {
                                0%, 100% { transform: scaleY(1); }
                                50% { transform: scaleY(1.05); }
                            }
                        `}</style>
                    </svg>
                );
            case 8: // Plantas
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <ellipse cx="150" cy="120" rx="50" ry="40" fill="#2ecc71" className="pot"/>
                        <rect x="120" y="120" width="60" height="80" fill="#8b4513" rx="5"/>
                        <path d="M150 80 Q130 60 110 80 Q130 70 150 80" fill="#27ae60" className="leaf-1"/>
                        <path d="M150 80 Q170 60 190 80 Q170 70 150 80" fill="#27ae60" className="leaf-2"/>
                        <path d="M150 70 Q140 50 150 60 Q160 50 150 70" fill="#229954" className="leaf-3"/>
                        <circle cx="140" cy="75" r="8" fill="#f1c40f" className="drop-1"/>
                        <circle cx="160" cy="78" r="6" fill="#f1c40f" className="drop-2"/>
                        <text x="150" y="230" textAnchor="middle" fill="#7f8c8d" fontSize="12">24-48h SEM ÁGUA</text>
                        <style jsx>{`
                            .leaf-1, .leaf-2, .leaf-3 { animation: leafSway 3s ease-in-out infinite; }
                            .leaf-2 { animation-delay: 0.3s; }
                            .leaf-3 { animation-delay: 0.6s; }
                            @keyframes leafSway {
                                0%, 100% { transform: rotate(0deg); }
                                50% { transform: rotate(5deg); }
                            }
                            .drop-1, .drop-2 { animation: dropFall 2s ease-in-out infinite; }
                            .drop-2 { animation-delay: 0.5s; }
                            @keyframes dropFall {
                                0% { transform: translateY(0); opacity: 1; }
                                100% { transform: translateY(20px); opacity: 0; }
                            }
                        `}</style>
                    </svg>
                );
            case 9: // Estacionamento
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <rect x="50" y="150" width="200" height="100" fill="#34495e" rx="5"/>
                        <rect x="60" y="160" width="40" height="80" fill="#2c3e50" rx="3" className="parking-1"/>
                        <rect x="110" y="160" width="40" height="80" fill="#2c3e50" rx="3" className="parking-2"/>
                        <rect x="160" y="160" width="40" height="80" fill="#2c3e50" rx="3" className="parking-3"/>
                        <rect x="210" y="160" width="40" height="80" fill="#2c3e50" rx="3" className="parking-4"/>
                        <g className="truck-parking" transform="translate(100, 80)">
                            <rect x="0" y="0" width="100" height="50" fill="#e74c3c" rx="3"/>
                            <circle cx="20" cy="50" r="8" fill="#34495e"/>
                            <circle cx="80" cy="50" r="8" fill="#34495e"/>
                        </g>
                        <text x="150" y="140" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="bold">PERTO</text>
                        <style jsx>{`
                            .parking-1, .parking-2, .parking-3, .parking-4 { animation: parkingBlink 2s ease-in-out infinite; }
                            .parking-2 { animation-delay: 0.2s; }
                            .parking-3 { animation-delay: 0.4s; }
                            .parking-4 { animation-delay: 0.6s; }
                            @keyframes parkingBlink {
                                0%, 100% { opacity: 0.5; }
                                50% { opacity: 1; }
                            }
                            .truck-parking { animation: truckPark 4s ease-in-out infinite; }
                            @keyframes truckPark {
                                0%, 100% { transform: translate(100px, 80px); }
                                50% { transform: translate(100px, 100px); }
                            }
                        `}</style>
                    </svg>
                );
            case 10: // Verificação Final
                return (
                    <svg viewBox="0 0 300 300" className="tip-svg">
                        <circle cx="150" cy="120" r="50" fill="none" stroke="#3498db" strokeWidth="4" className="magnify-ring"/>
                        <line x1="180" y1="150" x2="220" y2="190" stroke="#3498db" strokeWidth="4" strokeLinecap="round" className="magnify-handle"/>
                        <rect x="100" y="100" width="100" height="40" fill="#2ecc71" opacity="0.3" className="check-area"/>
                        <path d="M120 125 L135 140 L160 115" fill="none" stroke="#2ecc71" strokeWidth="4" strokeLinecap="round" className="check-mark"/>
                        <rect x="80" y="200" width="140" height="60" fill="#fff" stroke="#95a5a6" strokeWidth="2" rx="5" className="checklist"/>
                        <line x1="100" y1="220" x2="180" y2="220" stroke="#2ecc71" strokeWidth="3" className="check-line-1"/>
                        <line x1="100" y1="240" x2="170" y2="240" stroke="#2ecc71" strokeWidth="3" className="check-line-2"/>
                        <line x1="100" y1="250" x2="160" y2="250" stroke="#95a5a6" strokeWidth="2" className="check-line-3"/>
                        <style jsx>{`
                            .magnify-ring { animation: magnifyMove 3s ease-in-out infinite; }
                            @keyframes magnifyMove {
                                0%, 100% { transform: translate(0, 0); }
                                50% { transform: translate(10px, -10px); }
                            }
                            .check-mark { stroke-dasharray: 50; stroke-dashoffset: 50; animation: checkDraw 1.5s ease-in-out 0.5s forwards; }
                            @keyframes checkDraw { to { stroke-dashoffset: 0; } }
                            .check-line-1, .check-line-2 { stroke-dasharray: 80; stroke-dashoffset: 80; }
                            .check-line-1 { animation: lineDraw 1s ease-in-out 1.5s forwards; }
                            .check-line-2 { animation: lineDraw 1s ease-in-out 2s forwards; }
                            @keyframes lineDraw { to { stroke-dashoffset: 0; } }
                        `}</style>
                    </svg>
                );
            default:
                return null;
        }
    };
    
    const CaseLeftThumb = ({data}) => {
        return (
            <>
            <div className="col-lg-6">
                <div className={`case-study-featured-thumb thumb-${data.id}`}>
                <Tilty perspective={2000}>
                    <div className="tip-animation-wrapper">
                        {getTipAnimation(data.id)}
                    </div>
                </Tilty>
                </div>
            </div>
            <div className="col-xl-5 col-lg-6 offset-xl-1">
                <div className="case-study-featured">
                <div className="section-heading heading-left">
                    <span className="subtitle">{data.subtitle}</span>
                    <h2 className="title">{data.title}</h2>
                    <p>{data.excerpt}</p>
                </div>
                </div>
            </div>
            </>
        )
    }
    
    const CaseRightThumb = ({data}) => {
        return (
            <>
            <div className="col-lg-6 offset-xl-1 order-lg-2">
                <div className={`case-study-featured-thumb thumb-${data.id}`}>
                <Tilty perspective={2000}>
                    <div className="tip-animation-wrapper">
                        {getTipAnimation(data.id)}
                    </div>
                </Tilty>
                </div>
            </div>
            <div className="col-lg-5 order-lg-1">
                <div className="case-study-featured">
                <div className="section-heading heading-left">
                    <span className="subtitle">{data.subtitle}</span>
                    <h2 className="title">{data.title}</h2>
                    <p>{data.excerpt}</p>
                </div>
                </div>
            </div>
            </>
        )
    }

    return (
        <>
            {allData.map((data) => (
                <div className="row" key={data.id}> 
                    {(data.id % 2  === 0) ? <CaseRightThumb data={data}/> : <CaseLeftThumb data={data}/>}
                </div>
            ))}
            <style jsx global>{`
                .tip-animation-wrapper {
                    width: 100%;
                    height: 300px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .tip-svg {
                    width: 100%;
                    height: 100%;
                    max-width: 300px;
                    max-height: 300px;
                }
                @media (max-width: 991px) {
                    .tip-animation-wrapper {
                        display: none !important;
                    }
                }
            `}</style>
        </>
    )
}

export default CaseStudyProp;